<template>
    <div class="content">
      <div class="container-fluid">
        <div class="row">
  <b-modal
    id="modal-top-add-bulk"
    hide-footer
    title="Add Customer"
    content-class="shadow"
  >
   <!-- Loading Indicator -->
   <div v-if="loading" class="text-center mb-3">
    <b-spinner label="Loading..."></b-spinner>
    <p>Please wait while we upload your data.</p>
  </div>
    <!-- Modal Header -->
    <template #modal-header="{ close }">
      <h5>{{ translate('addBulkData') }}</h5>
      <p class="h5 mb-2">
        <b-icon
          icon="x-square"
          class="close-icon"
          @click="
            close();
            clearData();
          "
        ></b-icon>
      </p>
    </template>

    <!-- Download Sample File Button -->
    <b-row class="mb-3">
      <b-col md="12" class="text-center">
        <b-button
          variant="success"
          @click="downloadSampleFile"
        >
          {{ translate('downloadSampleFile') }}
        </b-button>
      </b-col>
    </b-row>

    <!-- File Upload Section -->
    <b-row>
      <b-col md="12">
        <label>{{ translate('uploadExcelFile') }}</label>
        <b-form-file
          v-model="file"
          @change="onFileSelected"
          ref="fileInput"
          accept=".csv, .xls, .xlsx"
          class="mb-2"
        ></b-form-file>
      </b-col>
    </b-row>

    <!-- Submit Button -->
    <b-row>
      <b-col md="12">
        <b-button
          variant="primary"
          @click="confirmAndSubmitFile"
          :disabled="loading" 
        >
        {{ translate('submit') }}
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</div>
         <div class="row">
          <b-modal
              id="modal-top-add"
              hide-footer
              title="Linking Ekub"
              content-class="shadow" 
              size="lg"
            >
              <template #modal-header="{ close }">
                  <h5>{{ translate('linkingAssociation') }}</h5>
                  <p class="h5 mb-2">
                    <b-icon
                      icon="x-square"
                      class="close-icon"
                      @click="
                        close();
                        clearData();
                      "
                    ></b-icon>
                  </p>
              </template>
               <b-tabs v-model="tabIndex" small card>
                   <validation-observer ref="observer" v-slot="{ handleSubmit }">
                    <b-form
                      class="text-left"
                      @submit.stop.prevent="handleSubmit(submitAddForm)"
                    >
                      <b-tab>
                        <template #title>
                          <span style="color: rgb(37, 91, 48) !important; font-size: 15px !important; font-weight: 600 !important;">
                            <b-icon icon="house"></b-icon> <span class="mob-title">{{ translate('associationTypeInfo') }}</span>
                          </span>
                        </template>
                        <b-form-checkbox v-model="checkedExistingEkubType" name="check-button" switch>
                         {{ translate('existingAssociationType') }}
                       </b-form-checkbox>
                       <template v-if="checkedExistingEkubType">
                      <!-- Select Existing Ekub Type -->
                      <b-col md="12" style="justify-content: center; align-items: center">
                        <Vselect
                          :modelValue="addData.ekubId"
                          @update:modelValue="(newValue) => { addData.ekubId = newValue }"
                          :options="ekubTypeOptions"
                          :rules="{ required: true }"
                          id="text-ekubType"
                          name="text-ekubType"
                          :label="translate('associationType')"
                          class="mb-1 mr-sm-2"
                          description="text-ekubType-feedback"
                          validatorName="Association Type"
                        />
                      </b-col>
                      <!-- Display Ekub Info for Existing Type -->
                      <b-col
                        v-if="addData.ekubId !== null && addData.ekubId !== 0"
                        md="12"
                        style="justify-content: center; align-items: center"
                      >
                        <Vinput
                          inputType="text"
                          :modelValue="getNumberOfEkuber"
                          :rules="{}"
                          id="text-numberOfEkuber"
                          name="text-numberOfEkuber"
                          :label="translate('numberOfAssociationMembers')"
                          class="mb-1 mr-sm-2"
                          description="text-numberOfEkuber-feedback"
                          validatorName="Number Of Association Members"
                          disabled
                        />
                      </b-col>
                      <b-col
                        v-if="addData.ekubId !== null && addData.ekubId !== 0"
                        md="12"
                        style="justify-content: center; align-items: center"
                      >
                        <Vinput
                          inputType="text"
                          :modelValue="getEkubAmount"
                          :rules="{}"
                          id="text-ekubAmount"
                          name="text-ekubAmount"
                          :label="translate('amount')"
                          class="mb-1 mr-sm-2"
                          description="text-ekubAmount-feedback"
                          validatorName="Ekub Amount"
                          disabled
                        />
                      </b-col>
                    </template>
                     <template v-else>
                      <b-col
                            md="12"
                            style="justify-content: center; align-items: center"
                          >
                            <Vinput
                              inputType="text"
                              :modelValue="addData.ekubName"
                              @update:modelValue="
                                (newValue) => (addData.ekubName = newValue)
                              "
                              :rules="{ required: true }"
                              id="text-ekubName"
                              name="text-ekubName"
                              :label="translate('associationName')"
                              class="mb-1 mr-sm-2"
                              description="text-ekubName-feedback"
                              validatorName="Association Name"
                            />
                          </b-col>
                          <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                       <Vselect
                        :modelValue="addData.ekubType"
                        @update:modelValue="
                          (newValue) => (addData.ekubType = newValue)
                        "
                          :options="ekubTypeOptions"
                        :rules="{ required: true }"
                        id="text-ekub-type-options"
                        name="text-ekub-type-options"
                       :label="translate('associationType')"
                        class="mb-1 mr-sm-2 some-select"
                        description="text-ekub-type-options-feedback"
                        validatorName="Association Type"
                      />
                    </b-col>
                          <b-col
                            md="12"
                            style="justify-content: center; align-items: center"
                          >
                            <VinputNumber
                              inputType="number"
                              :modelValue="addData.ekubAmount"
                              @update:modelValue="
                                (newValue) => (addData.ekubAmount = newValue)
                              "
                              :rules="{  required: true  }"
                              id="text-ekubAmount"
                              name="text-ekubAmount"
                              :label="translate('associationAmount')"
                              class="mb-1 mr-sm-2"
                              description="text-ekubAmount-feedback"
                              validatorName="Association Amount"
                              :step=".01"
                            />
                          </b-col>
                          <b-row style="margin-left: 0px;">
                          <b-col
                            xs="1"
                            style="justify-content: center; align-items: center"
                          >
                           <Vselect
                            :modelValue="addData.cycle"
                            @update:modelValue="
                              (newValue) => (addData.cycle = newValue)
                            "
                              :options="cycleOptions"
                            :rules="{ required: true }"
                            id="text-cycle"
                            name="text-cycle"
                            :label="translate('cycle')"
                            class="mb-1 mr-sm-2 some-select"
                            description="text-cycle-feedback"
                            validatorName="Cycle"
                          />
                          </b-col>
                           <b-col
                            xs="2"
                            style="justify-content: center; align-items: center"
                          >
                          <Vselect
                            :modelValue="addData.cycletwo"
                            @update:modelValue="
                              (newValue) => (addData.cycletwo = newValue)
                            "
                              :options="cycleOptions2"
                            :rules="{ required: true }"
                            id="text-cycletwo"
                            name="text-cycletwo"
                            label="*"
                            class="mb-1 mr-sm-2 some-select"
                            description="text-cycletwo-feedback"
                            validatorName="Cycle"
                          />
                          </b-col>
                          <!-- hellohello -->
                          <b-col
                            xs="9"
                            style="justify-content: right; align-items: right"
                          ></b-col>
                          </b-row>
                          <b-col
                            md="12"
                            style="justify-content: center; align-items: center"
                          >
                          <VinputNumber
                              inputType="number"
                              :modelValue="addData.numberOfEkuber"
                              @update:modelValue="
                                (newValue) => (addData.numberOfEkuber = newValue)
                              "
                              :rules="{ required: true }"
                              id="text-numberOfEkuber"
                              name="text-numberOfEkuber"
                              :label="translate('numberOfEkuber')"
                              class="mb-1 mr-sm-2"
                              description="text-numberOfEkuber-feedback"
                              validatorName="Number Of Ekuber"
                              :step=".01"
                            />
                          </b-col>
                          <b-col
                            md="12"
                            style="justify-content: center; align-items: center"
                          >
                            <Vinput
                              inputType="date"
                              :modelValue="addData.startDate"
                              @update:modelValue="
                                (newValue) => (addData.startDate = newValue)
                              "
                              :rules="{ required: true }"
                              id="text-startDate"
                              name="text-startDate"
                              :label="translate('startDate')"
                              class="mb-1 mr-sm-2"
                              description="text-startDate-feedback"
                              validatorName="Start Date"
                            />
                          </b-col>
                           <b-col
                            md="12"
                            style="justify-content: center; align-items: center"
                          >
                            <Vinput
                            
                              inputType="date"
                              :modelValue="addData.endDate"
                              @update:modelValue="
                                (newValue) => (addData.endDate = newValue)
                              "
                              :rules="{ required: true }"
                              id="text-endDate"
                              name="text-endDate"
                              :label="translate('endDate')"
                              class="mb-1 mr-sm-2"
                              description="text-endDate-feedback"
                              validatorName="End Date"
                            />
                          </b-col>
                          <b-col
                            md="12"
                            style="justify-content: center; align-items: center"
                          >
                          <Vinput
                              inputType="text"
                              :modelValue="addData.ekubTypeDescription"
                              @update:modelValue="
                                (newValue) => (addData.ekubTypeDescription = newValue)
                              "
                              :rules="{  }"
                              id="text-description"
                              name="text-description"
                              :label="translate('description')"
                              class="mb-1 mr-sm-2"
                              description="text-description-feedback"
                              validatorName="Description"
                            />
                          </b-col>
                        </template>
                      </b-tab>
                      <b-tab>
                        <template #title>
                          <span style="color: rgb(37, 91, 48) !important; font-size: 15px !important; font-weight: 600 !important;">
                          <b-icon icon="people-fill"></b-icon> <span class="mob-title">{{ translate('associationMember') }}</span>
                          </span>
                        </template>
                        <b-form-checkbox v-model="checkedExistingEkubMember" name="check-button" switch>
                          {{ translate('existingAssociationMember') }}
                        </b-form-checkbox>
                        <template v-if="checkedExistingEkubMember">
                  <!-- Select Existing Ekub Member -->
                  <b-col md="12" style="justify-content: center; align-items: center">
                     <Vselect
                          :modelValue="addData.ekubJoinerId"
                          @update:modelValue="(newValue) => { addData.ekubJoinerId = newValue }"
                          :options="ekubMemberOptions"
                          :rules="{ required: true }"
                          id="text-ekubMember"
                          name="text-ekubMember"
                          :label="translate('associationMember')"
                          class="mb-1 mr-sm-2"
                          description="text-ekubMember-feedback"
                          validatorName="Association Member"
                        />
                        </b-col>
                        </template>
                        <template v-else>
                          <b-col
                            md="12"
                            style="justify-content: center; align-items: center"
                          >
                            <Vinput
                              inputType="text"
                              :modelValue="addData.fullName"
                              @update:modelValue="
                                (newValue) => (addData.fullName = newValue)
                              "
                              :rules="{ required: true }"
                              id="text-fullName"
                              name="text-fullName"
                              :label="translate('fullName')"
                              class="mb-1 mr-sm-2"
                              description="text-fullName-feedback"
                              validatorName="Full Name"
                            />
                          </b-col>
                          <b-col
                            md="12"
                            style="justify-content: center; align-items: center"
                          >
                            <Vinput
                              inputType="text"
                              :modelValue="addData.email"
                              @update:modelValue="
                                (newValue) => (addData.email = newValue)
                              "
                              :rules="{regex:/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/}"
                              id="text-email"
                              name="text-email"
                              :label="translate('email')"
                              class="mb-1 mr-sm-2"
                              description="text-email-feedback"
                              validatorName="Email"
                            />
                          </b-col>
                            <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                       <Vselect
                        :modelValue="addData.sex"
                        @update:modelValue="
                          (newValue) => (addData.sex = newValue)
                        "
                          :options="sexOptions"
                        :rules="{ required: true }"
                        id="text-sex"
                        name="text-sex-options"
                        :label="translate('sex')"
                        class="mb-1 mr-sm-2 some-select"
                        description="text-sex-feedback"
                        validatorName="Sex"
                      />
                    </b-col>
                          <b-col
                            md="12"
                            style="justify-content: center; align-items: center"
                          >
                            <VinputGroup
                              inputType="text"
                              :modelValue="addData.phoneNumber"
                              @update:modelValue="
                                (newValue) => (addData.phoneNumber = newValue)
                              "
                              :rules="{ required: true, regex:/^\d{9}$/ }"
                              id="text-phoneNumber"
                              name="text-phoneNumber"
                              :label="translate('phoneNumber')"
                              class="mb-1 mr-sm-2"
                              description="text-phoneNumber-feedback"
                              validatorName="Phone Number"
                              prepend="+251"
                            />
                          </b-col>
                          <b-col
                            md="12"
                            style="justify-content: center; align-items: center"
                          >
                            <Vinput
                              inputType="text"
                              :modelValue="addData.address"
                              @update:modelValue="
                                (newValue) => (addData.address = newValue)
                              "
                              :rules="{ required: true }"
                              id="text-address"
                              name="text-address"
                              :label="translate('address')"
                              class="mb-1 mr-sm-2"
                              description="text-address-feedback"
                              validatorName="Address"
                            />
                          </b-col>
                          <b-col
                            md="12"
                            style="justify-content: center; align-items: center"
                          >
                            <Vinput
                              inputType="text"
                              :modelValue="addData.job"
                              @update:modelValue="
                                (newValue) => (addData.job = newValue)
                              "
                              :rules="{}"
                              id="text-job"
                              name="text-job"
                              :label="translate('job')"
                              class="mb-1 mr-sm-2"
                              description="text-job-feedback"
                              validatorName="Job"
                            />
                          </b-col>
                          <b-col
                            md="12"
                            style="justify-content: center; align-items: center"
                          >
                            <Vinput
                              inputType="text"
                              :modelValue="addData.idNumber"
                              @update:modelValue="
                                (newValue) => (addData.idNumber = newValue)
                              "
                              :rules="{}"
                              id="text-idNumber"
                              name="text-idNumber"
                              :label="translate('idNumber')"
                              class="mb-1 mr-sm-2"
                              description="text-ID Number-feedback"
                              validatorName="idNumber"
                            />
                          </b-col>
                          <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                   <Vinput
                        inputType="text"
                        :modelValue="addData.memberDescription"
                        @update:modelValue="
                          (newValue) => (addData.memberDescription = newValue)
                        "
                        :rules="{}"
                        id="text-description"
                        name="text-description"
                        :label="translate('description')"
                        class="mb-1 mr-sm-2"
                        description="text-description-feedback"
                        validatorName="Description"
                      />
                     </b-col>
                        </template>
                      </b-tab>
                      <b-tab>
                        <template #title>
                          <span style="color: rgb(37, 91, 48) !important; font-size: 15px !important; font-weight: 600 !important;">
                          <b-icon icon="ui-checks"></b-icon> <span class="mob-title"> {{ translate('associationLinkage') }}</span>
                          </span>
                        </template>
                        <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                       <Vselect
                        :modelValue="addData.amount"
                        @update:modelValue="
                          (newValue) => (addData.amount = newValue)
                        "
                          :options="numberOfEkubOptions"
                        :rules="{ required: true }"
                        id="text-ekub-type-options"
                        name="text-ekub-type-options"
                        :label="translate('numberOfShare')"
                        class="mb-1 mr-sm-2 some-select"
                        description="text-ekub-type-options-feedback"
                        validatorName="Number Of Share"
                      />
                    </b-col>
                          <template v-if="checkedExistingEkubType">
                          <b-col
                        v-if="addData.ekubId !== null && addData.ekubId !== 0"
                        md="12"
                        style="justify-content: center; align-items: center"
                      >
                        <Vinput
                          inputType="text"
                          :modelValue="getEkubAmount*addData.amount"
                          :rules="{}"
                          id="text-ekubAmount"
                          name="text-ekubAmount"
                          :label="translate('amount')"
                          class="mb-1 mr-sm-2"
                          description="text-ekubAmount-feedback"
                          validatorName="Total Amount"
                          disabled
                        />
                      </b-col>
                    </template>
                    <template v-else>
                      <b-col
                        md="12"
                        style="justify-content: center; align-items: center"
                      >
                        <Vinput
                          inputType="text"
                          :modelValue="addData.ekubAmount*addData.amount"
                          :rules="{}"
                          id="text-ekubAmount"
                          name="text-ekubAmount"
                          :label="translate('totalAmount')"
                          class="mb-1 mr-sm-2"
                          description="text-ekubAmount-feedback"
                          validatorName="Total Amount"
                          disabled
                        />
                      </b-col>
                    </template>
                    <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                   <Vinput
                        inputType="text"
                        :modelValue="addData.linkingDescription"
                        @update:modelValue="
                          (newValue) => (addData.linkingDescription = newValue)
                        "
                        :rules="{}"
                        id="text-description"
                        name="text-description"
                        :label="translate('description')"
                        class="mb-1 mr-sm-2"
                        description="text-description-feedback"
                        validatorName="Description"
                      />
                     </b-col>
                           <!-- <b-col
                            md="12"
                            style="justify-content: center; align-items: center"
                          >
                          {{ translate('attachedDocument') }}
                          </b-col>
                          <b-col
                            md="12"
                            style="justify-content: center; align-items: center"
                          >
                          <b-form-file v-model="file" ref="file-input" class="mb-2"  accept=".jpg, .png"></b-form-file>
                          <p class="mt-2">Selected file: <b>{{ file ? file.name : '' }}</b></p>
                          </b-col> -->
                      </b-tab>
                      <b-tab>
                        <template #title>
                          <span style="color: rgb(37, 91, 48) !important; font-size: 15px !important; font-weight: 600 !important;">
                            <b-icon icon="clipboard-check"></b-icon> <span class="mob-title"> {{ translate('summary') }}</span>
                          </span>
                        </template>
                        <b-row>
                           <b-col
                              lg="6"
                              style="justify-content: center; align-items: center"
                            >
                              <b-card
                                border-variant="primary"
                                :header="translate('associationMember')"
                                header-bg-variant="primary"
                                header-text-variant="white"
                                align="center"
                              >
                            <template v-if="checkedExistingEkubMember">
                            <b-col md="12">
                              <Vinput
                                inputType="text"
                                :modelValue="getEkubMemberName"
                                @update:modelValue="(newValue) => { addData.ekubMemberId = newValue }"
                                :rules="{ required: true }"
                                id="text-ekubMember"
                                name="text-ekubMember"
                                :label="translate('associationMember')"
                                disabled
                              />
                            </b-col>
                          </template>
                          <template v-else>
                                  <b-col
                                    md="12"
                                    style="justify-content: center; align-items: center"
                                  >
                                    <Vinput
                                      inputType="text"
                                      :modelValue="addData.fullName"
                                      @update:modelValue="
                                        (newValue) => (addData.fullName = newValue)
                                      "
                                      :rules="{ required: true }"
                                      id="text-fullName"
                                      name="text-fullName"
                                      :label="translate('fullName')"
                                      class="mb-1 mr-sm-2"
                                      description="text-fullName-feedback"
                                      validatorName="Full Name"
                                      disabled="disabled"
                                    />
                                  </b-col>
                                  <b-col
                                    md="12"
                                    style="justify-content: center; align-items: center"
                                  >
                                    <Vinput
                                      inputType="text"
                                      :modelValue="addData.email"
                                      @update:modelValue="
                                        (newValue) => (addData.email = newValue)
                                      "
                                      :rules="{}"
                                      id="text-email"
                                      name="text-email"
                                      :label="translate('email')"
                                      class="mb-1 mr-sm-2"
                                      description="text-email-feedback"
                                      validatorName="Email"
                                      disabled="disabled"
                                    />
                                  </b-col>
                                  <b-col
                                    md="12"
                                    style="justify-content: center; align-items: center"
                                  >
                                  <Vinput
                                        inputType="text"
                                        :modelValue="addData.phoneNumber"
                                        @update:modelValue="
                                          (newValue) => (addData.phoneNumber = newValue)
                                        "
                                        :rules="{ required: true }"
                                        id="text-phoneNumber"
                                        name="text-phoneNumber"
                                        :label="translate('phoneNumber')"
                                        class="mb-1 mr-sm-2"
                                        description="text-phoneNumber-feedback"
                                        validatorName="Phone Number"
                                        disabled="disabled"
                                      />
                                  </b-col>
                                  <b-col
                                    md="12"
                                    style="justify-content: center; align-items: center"
                                  >
                                    <Vinput
                                      inputType="text"
                                      :modelValue="addData.address"
                                      @update:modelValue="
                                        (newValue) => (addData.address = newValue)
                                      "
                                      :rules="{ required: true }"
                                      id="text-address"
                                      name="text-address"
                                      :label="translate('address')"
                                      class="mb-1 mr-sm-2"
                                      description="text-address-feedback"
                                      validatorName="Address"
                                      disabled="disabled"
                                    />
                                  </b-col>
                                  <b-col
                                    md="12"
                                    style="justify-content: center; align-items: center"
                                  >
                                    <Vinput
                                      inputType="text"
                                      :modelValue="addData.job"
                                      @update:modelValue="
                                        (newValue) => (addData.job = newValue)
                                      "
                                      :rules="{}"
                                      id="text-job"
                                      name="text-job"
                                      :label="translate('job')"
                                      class="mb-1 mr-sm-2"
                                      description="text-job-feedback"
                                      validatorName="Job"
                                      disabled="disabled"
                                    />
                                  </b-col>
                                  <b-col
                                    md="12"
                                    style="justify-content: center; align-items: center"
                                  >
                                    <Vinput
                                      inputType="text"
                                      :modelValue="addData.idNumber"
                                      @update:modelValue="
                                        (newValue) => (addData.idNumber = newValue)
                                      "
                                      :rules="{}"
                                      id="text-idNumber"
                                      name="text-idNumber"
                                      :label="translate('idNumber')"
                                      class="mb-1 mr-sm-2"
                                      description="text-idNumber-feedback"
                                      validatorName="ID Number"
                                      disabled="disabled"
                                    />
                                  </b-col>
                                  <b-col
                                      md="12"
                                      style="justify-content: center; align-items: center"
                                    >
                                    <Vinput
                                        inputType="text"
                                        :modelValue="addData.memberDescription"
                                        @update:modelValue="
                                          (newValue) => (addData.memberDescription = newValue)
                                        "
                                        :rules="{ }"
                                        id="text-description"
                                        name="text-description"
                                        :label="translate('description')"
                                        class="mb-1 mr-sm-2"
                                        description="text-description-feedback"
                                        validatorName="Description"
                                        disabled="disabled"
                                      />
                                    </b-col>
                          </template>
                          </b-card>
                           </b-col>
                           <b-col
                              lg="6"
                              style="justify-content: center; align-items: center"
                            >
                              <b-card
                                  border-variant="primary"
                                  :header="translate('associationType')"
                                  header-bg-variant="primary"
                                  header-text-variant="white"
                                  align="center"
                                >
                            <template v-if="checkedExistingEkubType">  
                              <b-col md="12">
                                <Vinput
                                  inputType="text"
                                  :modelValue="getEkubTypeName"
                                  @update:modelValue="(newValue) => { addData.ekubTypeId = newValue }"
                                  :rules="{ required: true }"
                                  id="text-ekubTypeName"
                                  name="text-ekubTypeName"
                                  :label="translate('associationName')"
                                  disabled
                                />
                              </b-col>
                            </template>
                            <template v-else>
                                    <b-col
                                      md="12"
                                      style="justify-content: center; align-items: center"
                                    >
                                      <Vinput
                                        inputType="text"
                                        :modelValue="addData.ekubName"
                                        @update:modelValue="
                                          (newValue) => (addData.ekubName = newValue)
                                        "
                                        :rules="{}"
                                        id="text-ekubName"
                                        name="text-ekubName"
                                        :label="translate('associationName')"
                                        class="mb-1 mr-sm-2"
                                        description="text-ekubName-feedback"
                                        validatorName="Association Name"
                                        disabled="disabled"
                                      />
                                    </b-col>
                                    <b-col
                                      md="12"
                                      style="justify-content: center; align-items: center"
                                    >
                                      <Vinput
                                        inputType="text"
                                        :modelValue="addData.ekubType"
                                        @update:modelValue="
                                          (newValue) => (addData.ekubType = newValue)
                                        "
                                        :rules="{ }"
                                        id="text-ekubType"
                                        name="text-ekubType"
                                        :label="translate('associationType')"
                                        class="mb-1 mr-sm-2"
                                        description="text-ekubType-feedback"
                                        validatorName="Association Type"
                                        disabled="disabled"
                                      />
                                    </b-col>
                                    <b-col
                                      md="12"
                                      style="justify-content: center; align-items: center"
                                    >
                                      <VinputNumber
                                        inputType="number"
                                        :modelValue="addData.ekubAmount"
                                        @update:modelValue="
                                          (newValue) => (addData.ekubAmount = newValue)
                                        "
                                        :rules="{}"
                                        id="text-ekubAmount"
                                        name="text-ekubAmount"
                                        :label="translate('associationAmount')"
                                        class="mb-1 mr-sm-2"
                                        description="text-ekubAmount-feedback"
                                        validatorName="Association Amount"
                                        :step=".01"
                                        disabled="disabled"
                                      />
                                    </b-col>
                                    <b-col
                                      md="12"
                                      style="justify-content: center; align-items: center"
                                    >
                                    <VinputNumber
                                        inputType="number"
                                        :modelValue="addData.cycleDuration"
                                        @update:modelValue="
                                          (newValue) => (addData.cycleDuration = newValue)
                                        "
                                        :rules="{ required: true }"
                                        id="text-cycleDuration"
                                        name="text-cycleDuration"
                                        :label="translate('cycle')"
                                        class="mb-1 mr-sm-2"
                                        description="text-cycleDuration-feedback"
                                        validatorName="Cycle Duration"
                                        :step=".01"
                                        disabled="disabled"
                                      />
                                    </b-col>
                                    <b-col
                                      md="12"
                                      style="justify-content: center; align-items: center"
                                    >
                                    <VinputNumber
                                        inputType="number"
                                        :modelValue="addData.numberOfEkuber"
                                        @update:modelValue="
                                          (newValue) => (addData.numberOfEkuber = newValue)
                                        "
                                        :rules="{ required: true }"
                                        id="text-numberOfEkuber"
                                        name="text-numberOfEkuber"
                                        :label="translate('numberOfEkuber')"
                                        class="mb-1 mr-sm-2"
                                        description="text-numberOfEkuber-feedback"
                                        validatorName="Number Of Ekuber"
                                        :step=".01"
                                        disabled="disabled"
                                      />
                                    </b-col>
                                    <b-col
                                      md="12"
                                      style="justify-content: center; align-items: center"
                                    >
                                    <VinputNumber
                                        inputType="number"
                                        :modelValue="addData.cycleDuration"
                                        @update:modelValue="
                                          (newValue) => (addData.cycleDuration = newValue)
                                        "
                                        :rules="{ required: true }"
                                        id="text-cycle"
                                        name="text-cycle"
                                        :label="translate('cycle')"
                                        class="mb-1 mr-sm-2"
                                        description="text-cycle-feedback"
                                        validatorName="Cycle"
                                        :step=".01"
                                        disabled="disabled"
                                      />
                                    </b-col>
                                    <b-col
                                      md="12"
                                      style="justify-content: center; align-items: center"
                                    >
                                    <Vinput
                                        inputType="text"
                                        :modelValue="addData.ekubTypeDescription"
                                        @update:modelValue="
                                          (newValue) => (addData.ekubTypeDescription = newValue)
                                        "
                                        :rules="{ }"
                                        id="text-description"
                                        name="text-description"
                                        :label="translate('description')"
                                        class="mb-1 mr-sm-2"
                                        description="text-description-feedback"
                                        validatorName="Description"
                                        disabled="disabled"
                                      />
                                    </b-col>
                                  </template>
                                </b-card>
                           </b-col>
                        </b-row>
                         <b-row>
                           <b-col
                              lg="6"
                              style="justify-content: center; align-items: center"
                            >
                            <b-card
                              border-variant="primary"
                              :header="translate('linkageInformation')"
                              header-bg-variant="primary"
                              header-text-variant="white"
                              align="center"
                            >
                                <b-col
                                  md="12"
                                  style="justify-content: center; align-items: center"
                                >
                                  <VinputNumber
                                    inputType="number"
                                    :modelValue="addData.amount"
                                    @update:modelValue="
                                      (newValue) => (addData.amount = newValue)
                                    "
                                    :rules="{  }"
                                    id="text-amount"
                                    name="text-amount"
                                    :label="translate('numberOfShare')"
                                    class="mb-1 mr-sm-2"
                                    description="text-amount-feedback"
                                    validatorName="Mumber Of Ekub"
                                    :step=".01"
                                    disabled="disabled"
                                  />
                                </b-col>
                                <template v-if="checkedExistingEkubType">
                          <b-col
                        v-if="addData.ekubId !== null && addData.ekubId !== 0"
                        md="12"
                        style="justify-content: center; align-items: center"
                      >
                        <Vinput
                          inputType="text"
                          :modelValue="getEkubAmount*addData.amount"
                          :rules="{}"
                          id="text-ekubAmount"
                          name="text-ekubAmount"
                          :label="translate('totalAmount')"
                          class="mb-1 mr-sm-2"
                          description="text-ekubAmount-feedback"
                          validatorName="Total Amount"
                          disabled
                        />
                      </b-col>
                    </template>
                    <template v-else>
                      <b-col
                        md="12"
                        style="justify-content: center; align-items: center"
                      >
                        <Vinput
                          inputType="text"
                          :modelValue="addData.ekubAmount*addData.amount"
                          :rules="{}"
                          id="text-ekubAmount"
                          name="text-ekubAmount"
                          :label="translate('totalAmount')"
                          class="mb-1 mr-sm-2"
                          description="text-ekubAmount-feedback"
                          validatorName="Total Amount"
                          disabled
                        />
                      </b-col>
                    </template>
                    <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                   <Vinput
                        inputType="text"
                        :modelValue="addData.linkingDescription"
                        @update:modelValue="
                          (newValue) => (addData.linkingDescription = newValue)
                        "
                        :rules="{}"
                        id="text-description"
                        name="text-description"
                        :label="translate('description')"
                        class="mb-1 mr-sm-2"
                        description="text-description-feedback"
                        validatorName="Description"
                      />
                     </b-col>
                            </b-card>
                           </b-col>
                         </b-row>
                          <b-col class="mt-2">
                              <b-button type="submit" variant="primary">{{ translate('submit') }}</b-button>
                            </b-col>
                      </b-tab>
                      <b-row style="justify-content: end;">
                        <b-button-group class="mt-2">
                        <b-button class="btn-secondary" @click="tabIndex--">{{ translate('prev') }}</b-button>
                        <b-button class="btn-secondary" @click="tabIndex++">{{ translate('next') }}</b-button>
                        </b-button-group>
                      </b-row>
                    </b-form>
                   </validation-observer>
              </b-tabs>
            </b-modal> 
        </div>
        <!-- Terminate Modal -->
        <div class="row">
          <b-modal
            id="modal-terminate"
            hide-footer
            title="Terminate Association Linkage"
            content-class="shadow"
            size="lg"
          >
            <template #modal-header="{ close }">
              <h5>Terminate Association Linkage</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="close(); clearTerminateData();"
                ></b-icon>
              </p>
            </template>
            
            <!-- Search Section -->
            <b-row class="mb-3">
              <b-col md="6">
                <label>Phone Number</label>
                <div class="input-group">
                  <span class="input-group-text">+251</span>
                  <b-form-input 
                    v-model="terminateData.searchPhone" 
                    placeholder="Phone Number" 
                    type="tel"
                    maxlength="9">
                  </b-form-input>
                </div>
              </b-col>
              <b-col md="3">
                <label>&nbsp;</label>
                <b-button class="btn-secondary d-block" @click="searchForTerminate">Search</b-button>
              </b-col>
            </b-row>

            <!-- Results Section -->
            <div v-if="terminateData.searchResults.length > 0">
              <h6>Select Linkage to Terminate:</h6>
              <b-table
                :items="terminateData.searchResults"
                :fields="terminateFields"
                striped
                hover
                small
              >
                <template #cell(actions)="row">
                  <b-button 
                    size="sm" 
                    variant="danger" 
                    @click="confirmTerminate(row.item)"
                    :disabled="row.item.status === 'Terminated'"
                  >
                    {{ row.item.status === 'Terminated' ? 'Already Terminated' : 'Terminate' }}
                  </b-button>
                </template>
              </b-table>
            </div>
            
            <div v-else-if="terminateData.searched && terminateData.searchResults.length === 0">
              <p class="text-center text-muted">No linkages found for this phone number.</p>
            </div>
          </b-modal>
        </div>
        <div class="row">
          <b-modal
              id="modal-top-EditLinkage"
              hide-footer
              title="Edit Linkage"
              content-class="shadow" 
            >
              <template #modal-header="{ close }">
                <h5>{{ translate('editLinkage') }}</h5>
                <p class="h5 mb-2">
                  <b-icon
                    icon="x-square"
                    class="close-icon"
                    @click="
                      close();
                      clearData();
                    "
                  ></b-icon>
                </p>
              </template>
              <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <b-form
                  class="text-left"
                  @submit.stop.prevent="handleSubmit(submitEditForm)"
                >
                  <b-row no-gutters>
                    <b-col md="12" style="justify-content: center; align-items: center">
                        <Vselect
                          :modelValue="editData.ekubTypeId"
                          @update:modelValue="(newValue) => { editData.ekubTypeId = newValue }"
                          :options="ekubTypeOptions"
                          :rules="{ required: true }"
                          id="text-ekubType"
                          name="text-ekubType"
                          :label="translate('associationType')"
                          class="mb-1 mr-sm-2"
                          description="text-ekubType-feedback"
                          validatorName="Association Type"
                        />
                      </b-col>
                      <b-col md="12" style="justify-content: center; align-items: center">
                     <Vselect
                          :modelValue="editData.ekubMembers"
                          @update:modelValue="(newValue) => { editData.ekubMembers = newValue }"
                          :options="ekubMemberOptions"
                          :rules="{ required: true }"
                          id="text-ekubMember"
                          name="text-ekubMember"
                          :label="translate('associationMember')"
                          class="mb-1 mr-sm-2"
                          description="text-ekubMember-feedback"
                          validatorName="Association Member"
                        />
                        </b-col>
                        <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                       <Vselect
                        :modelValue="editData.numberOfEkub"
                        @update:modelValue="
                          (newValue) => (editData.numberOfEkub = newValue)
                        "
                          :options="numberOfEkubOptions"
                        :rules="{ required: true }"
                        id="text-ekub-type-options"
                        name="text-ekub-type-options"
                        :label="translate('numberOfShare')"
                        class="mb-1 mr-sm-2 some-select"
                        description="text-ekub-type-options-feedback"
                        validatorName="Number Of Share"
                      />
                    </b-col>
                          <b-col
                        v-if="editData.ekubTypeId !== null && editData.ekubTypeId !== 0"
                        md="12"
                        style="justify-content: center; align-items: center"
                      >
                        <Vinput
                          inputType="text"
                          :modelValue="getEkubAmountForEdit*editData.numberOfEkub"
                          :rules="{}"
                          id="text-ekubAmount"
                          name="text-ekubAmount"
                          :label="translate('associationAmount')"
                          class="mb-1 mr-sm-2"
                          description="text-ekubAmount-feedback"
                          validatorName="Total Amount"
                          disabled
                        />
                      </b-col>
       
                    <b-col class="mt-2">
                      <b-button type="submit" variant="primary">{{ translate('submit') }}</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
            </b-modal>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <card class="strpied-tabled-with-hover"
                  body-classes="table-full-width table-responsive"
            >
              <template slot="header">
                  <b-row>
                    <b-col lg="2" class="my-1">
                      <b-button v-if="modulePermission.create === 1" @click="triggerFileInput" class="btn-outline-primary">
                        <b-icon class="text-center" icon="plus"></b-icon> {{ translate('addBulkData') }}
                      </b-button>
                    </b-col>
                    <b-col lg="2" class="my-1">
                      <b-button class="btn-secondary" @click="toggleFilters">{{ showFilters ? 'Hide Filters' : 'Filter' }}</b-button>
                    </b-col>
                    <b-col lg="2" class="my-1">
                      <b-button class="btn-danger" @click="openTerminateModal">Terminate</b-button>
                    </b-col>
                    <b-col lg="4" class="my-1">
                      <b-form-group class="mb-0">
                        <b-input-group size="sm">
                          <b-form-input
                            id="filter-input"
                            v-model="filter"
                            type="search"
                            placeholder="Filter"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-button class="btn-secondary" :disabled="!filter" @click="filter = ''"
                              >Clear</b-button
                            >
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-collapse v-model="showFilters">
                    <b-row class="mt-3">
                      <b-col lg="2">
                        <label class="some-label" for="phone-number">{{ translate('phoneNumber') }}</label>
                        <div class="input-group">
                          <span class="input-group-text">+251</span>
                          <b-form-input 
                            id="phone-number" 
                            v-model="phoneNumber"  
                            :placeholder="translate('phoneNumber')" 
                            type="tel"
                            maxlength="9">
                          </b-form-input>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="mt-3">
                      <b-col lg="2">
                        <b-button class="btn-secondary" @click="searchByPhoneNumber()">{{ translate('find') }}</b-button>
                      </b-col>
                      <b-col lg="2">
                        <b-button class="btn-outline-secondary" @click="clearFilters">Clear</b-button>
                      </b-col>
                    </b-row>
                  </b-collapse>
              </template>
              <!-- Table Container with Scroll and Dynamic Height -->
            <div class="table-container">
              <b-table-simple
                :small="true"
                sticky-header
                style="max-height: 395px; position:relative;"
                striped
                responsive
                hover
              >
                <b-thead class="sticky-header">
                  <b-tr>
                    <b-th>{{ translate('no') }}</b-th>
                    <b-th>{{ translate('uniqueId') }}</b-th>
                    <b-th>{{ translate('memberName') }}</b-th>
                    <b-th>{{ translate('associationType') }}</b-th>
                    <b-th>{{ translate('amount') }}</b-th>
                    <b-th>{{ translate('startDate') }}</b-th>
                    <b-th>{{ translate('nextPaymentDate') }}</b-th>
                    <b-th>{{ translate('paymentStatus') }}</b-th>
                    <b-th>{{ translate('status') }}</b-th>
                    <b-th>{{ translate('createdAt') }}</b-th>
                    <b-th>{{ translate('createdBy') }}</b-th>
                    <b-th sticky-column style="height: 45px;"></b-th>
                  </b-tr>
                </b-thead>
                 <template v-if="spinner">
                  <b-tbody class="text-center">
                     <b-tr >
                         <b-td colspan="9" class="text-center" style="display: table-cell">
                          <b-spinner
                          style="height: 3rem; width: 3rem;"
                            variant="warning"
                          ></b-spinner>
                         </b-td>
                      </b-tr>
                  </b-tbody>
                  </template>
                  <template v-else>
                    <b-tbody>
                      <template v-if="filterTable.length === 0">
                          <b-tr>
                            <b-td colspan="9" class="text-center">{{ translate('nothingFound') }}</b-td>
                            <b-td></b-td>
                          </b-tr>
                      </template>
                      <template v-else>
                      <b-tr
                        v-for="(item, index) in filterTable"
                        :key="item.ID"
                      >
                          <b-td>{{(currentPage - 1) * perPage + index + 1}}</b-td>
                          <b-td>{{item.ekubUniqueId}}</b-td>
                          <b-td>{{item.ekubMembers.fullName}}</b-td>
                          <b-td>{{item.ekubType.ekubName}}</b-td>
                          <b-td>{{numberWithCommas(item.amountPerCycle)}}</b-td>
                          <b-td>{{item.startDate}}</b-td>
                          <b-td>{{item.nextPaymentDueDate}}</b-td>
                          <b-td >{{item.nextPaymentStatus}}</b-td>
                          <b-td >{{item.status}}</b-td>
                          <b-td>{{item.createdDate}}</b-td>
                          <b-td>{{item.registeredBy}}</b-td>
                          <b-td sticky-column>
                            <b-row>
                            <!-- <b-col md="4" class="mb-2">
                              <b-icon icon="eye-fill" class="btn-icon" title="View Detail" @click="ViewDetail(item.contractId)" aria-hidden="true" ></b-icon>
                            </b-col> -->
                              <!-- <template v-if="!disabledData"> -->
                            <b-col md="4" class="mb-2" v-if="modulePermission.update == 1">
                              <b-icon icon="pencil-square" class="btn-icon" :title="translate('editLinkage') " @click="EditLinkage(item.ekubLinkId)" aria-hidden="true" ></b-icon>
                            </b-col>
                
                            </b-row>
                          </b-td>
                      </b-tr>
                      </template>
                    </b-tbody>
                  </template>
              </b-table-simple>
            </div>
             <!-- Pagination outside the table to prevent overlap -->
            <div class="pagination-container">
              <b-row class="mt-3 align-items-center justify-content-between">
                <b-col class="d-flex align-items-center">
                  <label class="mr-2 mb-0">{{ translate('recordsPerPage') }}</label>
                  <b-form-select
                    id="input-horizontal"
                    class="custom-dropdown"
                    v-model="perPage"
                    :options="pageOptions"
                    @change="changePerPage"
                  >
                  </b-form-select>
                </b-col>
                <b-col class="d-flex justify-content-end">
                  <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="totalRows"
                    @page-click="changePage"
                    align="right"
                  />
                </b-col>
              </b-row>
            </div>
           </card>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
    import LTable from 'src/components/Table.vue'
    import Card from 'src/components/Cards/Card.vue'
    import Vinput from 'src/components/Inputs/Vinput.vue'
    import VinputGroup from 'src/components/Inputs/VinputGroup.vue'
    import VinputNumber from 'src/components/Inputs/VinputNumber.vue'
    import Vselect from 'src/components/Inputs/Vselect.vue'
    import VselectDouble from 'src/components/Inputs/VselectDouble.vue'
    import { setLanguage, translate } from 'src/i18n.js';
    export default {
      components: {
        LTable,
        Card,
        Vinput,
        VinputGroup,
        VinputNumber,
        Vselect,
        VselectDouble
      },
      data () {
        return {
          file: null,
          loading: false, // New loading state
          showFilters: false,
          phoneNumber: '',
          terminateData: {
            searchPhone: '',
            searchResults: [],
            searched: false
          },
          terminateFields: [
            { key: 'ekubUniqueId', label: 'Unique ID' },
            { key: 'ekubMembers.fullName', label: 'Member Name' },
            { key: 'ekubType.ekubName', label: 'Association' },
            { key: 'amountPerCycle', label: 'Amount' },
            { key: 'status', label: 'Status' },
            { key: 'actions', label: 'Action' }
          ],
          modulePermission: {
            view: 1,
            create: 0,
            update: 0,
            delete: 0
          },
          disableContractData: {
            billPaymentDate: "",
            buildingName: "", 
            contractIdentifier: "",
            createdDate: "",
            endDate: "",
            nextPaymentDate: "",
            remainingAmount: null,
            remainingBillPrice: null,
            remainingDate: "",
            roomNumber: "",
            startDate: "",
            status: null,
            tenantFullName:"", 
            tenantPhoneNumber: "",
            guaranteedMoney: null,
            guaranteedMoneyStatus: "",
            currencyType: "",
          },
          filter: "",
          totalRows: 0,
          pageOptions: [
            {value: 7, text: 7},
            {value: 10, text: 10},
            {value: 25, text: 25},
            {value: 50, text: 50},
            {value: 100, text: 100}
          ],
          currentPage: 1,
          perPage: 7,
          items: [],
          buildingOptions: [],
          rentCurrencyTypeOptions:[
            {value:"ETB", text:"ETB"},
            {value:"USD", text:"USD"}
          ],
          ekubTypeOptions: [
              {value: "Group", text: "Association"},
              {value: "Individual", text: "Individual"}
            ],
          ekubMemberOptions: [],
          ekubTypeOptions: [],
          periodOptions: [
            {text: 1, value: 1},
            {text: 2, value: 2},
            {text: 3, value: 3},
            {text: 4, value: 4},
            {text: 5, value: 5},
            {text: 6, value: 6},
            {text: 7, value: 7},
            {text: 8, value: 8},
            {text: 9, value: 9},
            {text: 10, value: 10},
            {text: 11, value: 11}
          ],
          numberOfEkubOptions: [
            {text: "One", value: 1},
            {text: "Two", value: 2},
            {text: "Three", value: 3},
            {text: "Four", value: 4},
            {text: "Five", value: 5}
          ],
          periodOptions2: [
            {text: "Monthly", value: 1},
            {text: "Yearly", value: 2}
          ],
          priceOptions: [
            {value:"PerSquareMeter", text: "Per Square Meter"},
            {value:"PerMonth", text: "Monthly"}
          ],
          sexOptions:[{value:"Male",text:"Male"},
          {value:"Female",text:"Female"}
          ],
      addData: {
        ekubAmount: null,
        ekubName: "",
        cycleDuration: 0,
        buildingId: null,
        numberOfEkuber: 0,
        ekubType: "",
        cycle: "",
        description: "",
        fullName: "",
        email: "",
        sex: "",
        phoneNumber: "",
        address: "",
        startDate: "",
        job: "",
        idNumber: "",
        Status: "",
        linkingDescription:"",
        ekubTypeDescription:"",
        memberDescription:"",
        amount: 0,
        amountPerOne: 0,
        startDate: 0,
        registeredBy: sessionStorage.getItem("userID"),
        ekubId: null,
        ekubJoinerId: null,
        ekubLinkingId: null,
      },
          editData:{
            ekubMembers: null,
            numberOfEkub: null,
            ekubTypeId: null,
          },
          selectedContract:{
            contractInformation: {
                nextPaymentDate: "",
                status: 0,
                paymentStatus: "",
                payedAmount: 0,
                startDate: "",
                endDate: "",
                createdDate: "",
                dueDate: 0,
                paymentRule: "",
                period: 0
            },
            guaranty: {
              guarantyAmount:"",
              currency:"",
              status:""
            },
            houseInformation: {
                floor: 0,
                roomNumber: "",
                size: 0,
                createdDate: "",
                status: 0,
                price: 0
            },
            buildingInformation: {
                buildingName: "",
                location: "",
                createdDate: "",
                status: 0,
                description: ""
            },
            tenantInformation: {
                fullName: "",
                email: "",
                phoneNumber: "",
                createdDate: "",
                address: "",
                status: 0
            },
            paymentHistory: [
            
            ],
            totalPayed: 0
          },
          houses: [],
          checkedExistingEkubType: false,
          checkedExistingEkubMember: false,
          tabIndex: 0,
          aboveSelected: false,
          belowSelected: false,
          file: null,
          base64: null,
          spinner: true,
          contractId: null,
          DateFrom: "",
          DateTo: "",
          ekubStatus: "NotCompleted",
          ekubStatusOptions: [
            {text: "Active", value: "NotCompleted"},
            {text: "Completed", value: "Completed"}
          ],
          cycleOptions: [
            {text: 1, value: 1},
            {text: 2, value: 2},
            {text: 3, value: 3},
            {text: 4, value: 4},
            {text: 5, value: 5},
            {text: 6, value: 6},
            {text: 7, value: 7},
          ],
          cycleOptions2: [
            {text: "Daily", value: 1},
            {text: "Weakly", value: 7},
            {text: "Monthly", value: 30},
            {text: "Yearly", value: 365}
          ],
          disabledData: false,
        }
      },
      watch: {
        file: function (newVal, oldVal) {
          if(newVal) {
              // console.log("some",newVal);
              this.createBase64Image(newVal);
          } else {
            this.base64 =null;
          }
        },
      },
  computed: {
        filterTable() {
          var searchItems = this.items;
          var searchString = this.filter;
          if (searchString === "") {
            return searchItems;
          }
          searchString = searchString.trim().toLowerCase();
  
          searchItems = searchItems.filter(function (item) {
            if (item.paymentStatus.toLowerCase().indexOf(searchString) !== -1 ||  item.tenant.fullName.toLowerCase().indexOf(searchString) !== -1 || String(item.house.floor).toLowerCase().indexOf(searchString) !== -1 || item.house.building.buildingName.toLowerCase().indexOf(searchString) !== -1 || item.house.roomNumber.toLowerCase().indexOf(searchString) !== -1 ) {
              return item;
            }
          });
          return searchItems;
        },
        daysMessage: function () {
          return "Due Date ("+ this.addData.dueDate+" Days)"
        },
        daysMessageEdit: function () {
          return "Due Date ("+ this.editData.dueDate+" Days)"
        },
    getEkubAmount() {
    var value = this.addData.ekubId; // Ensure the correct property is used
    if (value !== null && value !== "" && value !== 0) {
      const selectedEkub = this.ekubTypeOptions.find(item => item.value == value);
      return selectedEkub ? selectedEkub.ekubAmount : "";
    } else {
      return "";
    }
  },
  getEkubAmountForEdit() {
    var value = this.editData.ekubTypeId; // Ensure the correct property is used
    if (value !== null && value !== "" && value !== 0) {
      const selectedEkub = this.ekubTypeOptions.find(item => item.value == value);
      return selectedEkub ? selectedEkub.ekubAmount : "";
    } else {
      return "";
    }
  },
  getNumberOfEkuber() {
    var value = this.addData.ekubId; // Use `ekubId` here as well
    if (value !== null && value !== "" && value !== 0) {
      const selectedEkub = this.ekubTypeOptions.find(item => item.value == value);
      return selectedEkub ? selectedEkub.numberOfEkuber.toString() : "";
    } else {
      return "";
    }
  },
  
  getEkubTypeName() {
    var ekubName = "";
    var value = this.addData.ekubId;
    if (value !== null && value !== "" && value !== 0) {
      const selectedEkub = this.ekubTypeOptions.find(item => item.value == value);
      ekubName = selectedEkub ? selectedEkub.text : "";
    }
    return ekubName;
  },
    getEkubMemberName() {
    var ekubMember = "";
    var value = this.addData.ekubJoinerId;
    if (value !== null && value !== "" && value !== 0) {
      const selectedEkubMember = this.ekubMemberOptions.find(item => item.value == value);
      ekubMember = selectedEkubMember ? selectedEkubMember.text : "";
    }
    return ekubMember;
  },
        getPeriodWithSelected: function(){
          var period = "";
          var option = "";
          if(this.addData.period !== 0 && this.addData.period !== null ){
            period  = this.periodOptions.filter(x=>x.value== this.addData.period)[0].text;
            option  = this.periodOptions2.filter(x=>x.value== this.addData.periodtwo)[0].text;
          }
          return period + " " + option;
        },
        computedPrice(){
          if(this.addData.priceOption == "PerSquareMeter"){
            if(this.addData.size !== null && this.addData.latest_price !==null) return this.addData.size * this.addData.latest_price;
            else return null
          }else{
            return null
          }
        }
      },
       mounted() {
        this.getModules();
        this.getEkubLinks();
        this.getEkubLinksByOwnerID();
        this.getEkubsByOwnerID();
        this.getCustomerByOwnerID();
        this.getEkubsByAll();
        this.$on("AfterComplete", () => {
          this.getEkubLinks();
          this.getEkubLinksByOwnerID();
          this.getEkubsByOwnerID();
          this.getCustomerByOwnerID();
          this.getEkubsByAll();
        });
      },
      methods: {
        translate,
      changeLanguage(lang) {
        setLanguage(lang);
        this.$forceUpdate();
      },
      // Trigger file input (when Add Bulk Data button is clicked)
    triggerFileInput() {
        this.$bvModal.show('modal-top-add-bulk');
      },
  
      // Handle file selection
      onFileSelected(file) {
        if (!file) {
          this.file = null;
          alert('No file selected.');
          return;
        }
        this.file = file;
        // console.log('File selected:', file.name); // Debugging
      },
  
      // Confirm and submit file
      confirmAndSubmitFile() {
        this.$bvModal
          .msgBoxConfirm(translate('areYouSureYouWantToSubmitThisForm'), {
            title: translate('confirm'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            cancelVariant: 'danger',
            okTitle:  translate('yes'),
            cancelTitle: translate('nono'),
            bodyClass: 'm-2',
            hideHeaderClose: false,
            centered: false,
          })
          .then((confirmed) => {
            if (confirmed) {
              this.submitFile();
            }
          })
          .catch((err) => {
            console.error('Modal closed without confirmation:', err);
          });
      },
  
      // Submit the file (parse and send to API)
    submitFile() {
      if (!this.file) {
        alert('Please select a file before submitting.');
        return;
      }
      this.loading = true; // Set loading to true
      const fileExtension = this.file.name.split('.').pop().toLowerCase();
      if (fileExtension === 'csv') {
        this.parseCSV(this.file);
      } else if (fileExtension === 'xls' || fileExtension === 'xlsx') {
        this.parseExcel(this.file);
      } else {
        alert('Please upload a CSV or Excel file.');
        this.loading = false; // Reset loading state
      }
    },
  
     // Parse CSV file without external library
    parseCSV(file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const fileContent = event.target.result;
        console.log('CSV file content:', fileContent);  // Debugging
  
        // Manually parse the CSV data
        const parsedData = this.csvToJson(fileContent);
  
        // Map the CSV data to the expected JSON format
        const jsonData = this.mapDataToJson(parsedData);
        this.sendDataToAPI(jsonData);
      };
      reader.readAsText(file);
    },
    // Convert CSV to JSON format
    csvToJson(csv) {
      const lines = csv.split('\n');
      const result = [];
      const headers = lines[0].split(','); // Assuming the first line is the header
  
      // Iterate over the remaining lines (data rows)
      for (let i = 1; i < lines.length; i++) {
        const currentLine = lines[i].split(',');
        if (currentLine.length === headers.length) { // Ensure the row matches the header length
          const obj = {};
          for (let j = 0; j < headers.length; j++) {
            obj[headers[j].trim()] = currentLine[j].trim();
          }
          result.push(obj);
        }
      }
  
      return result;
    },
  
      // Map data to JSON
      mapDataToJson(data) {
        return data.map((item) => ({
          userId: sessionStorage.getItem("ID"),
          phoneNumber: item['phoneNumber'],
          email: item['email'],
          fullName: item['fullName'],
          sex: item['sex'],
          idNumber: item['idNumber'],
          job: item['job'],
          address: item['address'],
          paidTotalAmount: item['paidTotalAmount'],
          memberDescription: item['Description'],
          linkingDescription: item['Description'],
          associationId: item['associationId'],
          numberOfEkub:item['entryCount'],
          registeredBy: parseInt(sessionStorage.getItem("userID")),
          superUserId: parseInt(sessionStorage.getItem("superID"))
        }));
      },
  // Convert date format from MM/dd/yyyy to yyyy-MM-dd
convertDateFormat(dateStr) {
  const date = new Date(dateStr);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed, so add 1
  const day = date.getDate().toString().padStart(2, '0'); // Ensure day is always two digits
  return `${year}-${month}-${day}`;
},
      // Send data to API
      sendDataToAPI(data) { 
        this.$store
          .dispatch('AddBulkAssociationLinkage', data)
          .then((response) => {
            this.$notifications.notify({
              message: `<span>Data uploaded successfully:</span>`,
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'success',
            });
            this.$bvModal.hide('modal-top-add-bulk');
            this.clearData();
            setTimeout(() => {
              location.reload();
            }, 2000); // Adjust delay as needed
          })
          .catch((error) => {
            console.error('API Error:', error); // Debugging
            this.$notifications.notify({
              message: (error.response && error.response.data) || 'Upload failed.',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger',
            });
            this.clearData();
            // Reload the page after a delay
      setTimeout(() => {
      location.reload();
      }, 2000); // Adjust delay as needed
          });
      },
    // Download sample file
    downloadSampleFile() {
      const sampleData = [
        ['Number','associationId', 'phoneNumber', 'email', 'fullName', 'sex', 'idNumber', 'job', 'address','entryCount', 'paidTotalAmount','Description'],
        [1,'100001','922334455', 'abcd@example.com', 'Abebe Kebede', 'Male', '1234567890', 'Engineer', '123 Main St',1, '1200', 'Any description about the member 1'],
        [2,'100001','911223344', 'abcdef@example.com', 'Aster Solomon', 'Female', 'ABCD_1234', 'Doctor', '456 Oak St',1,'400', 'Any description about the member 2'],
      ];
      // Add BOM for UTF-8 encoding
  let csvContent = '\ufeff'; // BOM
  sampleData.forEach((rowArray) => {
    const row = rowArray.join(',');
    csvContent += row + '\r\n';
  });

  const encodedUri = encodeURI('data:text/csv;charset=utf-8,' + csvContent);
  const link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', 'sample-file.csv');
  link.click();
    },
    getCustomerByOwnerID() {
      this.$store.dispatch('getAllMembers', { userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")) })
        .then(response => {
          // console.log("member ",response.data);
          this.ekubMemberOptions = response.data.map((value) => ({
            value: value.customerId,       // Make sure the `value` field matches the selected value in Vselect
            text: value.fullName,  // `text` field will be displayed in the dropdown
          }));
  
          // Set the first ekubMemberId in addData (if available)
          if (response.data.length > 0) {
            this.addData.ekubJoinerId = response.data[0].id;  // Bind to `addData.ekubJoinerId`
          }
        })
        .catch(error => {
          this.$notify({
            title: 'Error',
            text: error.response.data,
            type: 'error'
          });
        });
    },
    getEkubsByOwnerID() {
    this.$store.dispatch('getAllAssociation', { userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")) })
      .then(response => {
        this.ekubTypes = response.data; 
      })
      .catch(error => {
        this.$notify({
          title: 'Error',
          text: error.response.data,
          type: 'error'
        });
      });
  },
  getEkubsByAll() {
    this.$store.dispatch('getAllAssociationDashboard', { userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")) })
      .then(response => {
        this.ekubTypes = response.data;  
        this.ekubTypeOptions = this.ekubTypes.map(ekub => ({
          value: ekub.id,            // 'value' for Vselect
          text: ekub.ekubName,       // 'text' for Vselect
          ekubType: ekub.ekubType,   // The ekubType for potential use
          ekubAmount: ekub.ekubAmount, // Amount for calculated display
          numberOfEkuber: ekub.numberOfEkuber, // Number of members for display
          cycle: ekub.cycle,         // Cycle duration for calculated display
          cycleDuration: ekub.cycleDuration // Cycle duration for calculated display
        }));
      })
      .catch(error => {
        this.$notify({
          title: 'Error',
          text: error.response.data,
          type: 'error'
        });
      });
  },
        getModules(){
          this.$store.dispatch('getModulesPermission', {userId: sessionStorage.getItem("userID")})
            .then(response=>{
                //this.items = response.data;
                // console.log("somemodules", response.data.modules);
                var modulesList = response.data.modules;
                var EkubLinksModule = modulesList.filter(x=>x.name === "Association_Linkage_Super");
                if(EkubLinksModule !== null){
                  this.modulePermission.view = EkubLinksModule[0].listData;
                  this.modulePermission.create = EkubLinksModule[0].createData;
                  this.modulePermission.update = EkubLinksModule[0].updateData;
                  this.modulePermission.delete = EkubLinksModule[0].deleteData;
                }
            })
            .catch(error=>{
                //console.log(error);
            })
        },
        createBase64Image(FileObject) {
          const reader = new FileReader();
          reader.onload = (event) => {
            //console.log("event", event.target.result);
            this.base64=event.target.result;
          }
          reader.readAsDataURL(FileObject);
        },
        getPeriod(period){
          var periodValue = this.periodOptions.filter(x=>x.value == period);
          if(period == null || period == 0){
            return "";
          }else{
            return "Every " + periodValue[0].text + " months"
          }
        },
        getPaymentCondition(condition){
          if(condition.toLowerCase() == "above"){
            return "Advance Payment Permitted";
          }else if(condition.toLowerCase() == "below"){
            return "Partial Payment Permitted";
          }
          else if(condition.toLowerCase() == "yesboth"){
            return "Both Advance and Partial Payment are Permitted";
          }else{
            return "Neither Advance Nor Partial Payment Permitted";
          }
        },
        getStatus(status){
          return status == 1 ? "Rented" : "Free";
        },
        numberWithCommas(x) {
          if(x !== null && x !== undefined){
              x = x.toFixed(2);
              return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }
        },
        getEkubLinks(){
           this.$store.dispatch('getEkubLinksByOwnerID',{userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID"))})
          .then(response=>{
            //console.log("building", response.data);
              Array.from(response.data).forEach((value) => {
              this.buildingOptions.push({
                value: value.buildingId,
                text: value.buildingName,
                billOption: value.billAmountOption
              });
            });
          })
          .catch(error=>{
              this.$notify({
                  title: 'Error',
                  text: error.response.data,
                  type: 'error'
              })
          })
        },
        getBillOptionByID(buildingId){
          if(buildingId !== "" && buildingId !== null){
            return this.buildingOptions.filter(x=>x.value === buildingId)[0].billOption;
          }
        },
  
        getEkubLinksByOwnerID(){
          this.spinner =true;
          if(this.DateEnd !== "" && this.DateEnd !== null && this.DateEnd !== undefined){
            if(this.ekubStatus === "Completed"){
              this.disabledData = false;
              this.$store.dispatch('getAllAssociationLinkageCompleted', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: this.currentPage, line: this.perPage, startDate: this.DateFrom, endDate: this.DateTo})
              .then(response=>{
                  // console.log("here",  response.data);
                  this.items = response.data.Contents;
                  // console.log("items ",this.items);
                  this.totalRows = response.data.totalElements;
              })
              .catch(error=>{
                  // this.$notify({
                  //     title: 'Error',
                  //     text: error.response.data,
                  //     type: 'error'
                  // })
                  //console.log(error);
              })
              .finally(msg=>{
                this.spinner =false;
              })
            }else{
              this.disabledData = true;
              this.$store.dispatch('getAllAssociationLinkageNotCompleted', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: this.currentPage, line: this.perPage, startDate: this.DateFrom, endDate: this.DateTo})
              .then(response=>{
              //console.log("here",  response.data);
                  this.items = response.data.Contents;
                  this.totalRows = response.data.totalElements;
              })
              .catch(error=>{
                  // this.$notify({
                  //     title: 'Error',
                  //     text: error.response.data,
                  //     type: 'error'
                  // })
                  //console.log(error);
              })
              .finally(msg=>{
                this.spinner =false;
              })
            }
          }else{
            if(this.ekubStatus === "Completed"){
              this.disabledData = false;
              this.$store.dispatch('getAllAssociationLinkageCompleted', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: this.currentPage, line: this.perPage})
              .then(response=>{
              //console.log("here",  response.data);
                  this.items = response.data.Contents;
                  this.totalRows = response.data.totalElements;
              })
              .catch(error=>{
                  // this.$notify({
                  //     title: 'Error',
                  //     text: error.response.data,
                  //     type: 'error'
                  // })
                  //console.log(error);
              })
              .finally(msg=>{
                this.spinner =false;
              })
            }else{
              this.disabledData = true;
              this.$store.dispatch('getAllAssociationLinkageNotCompleted', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: this.currentPage, line: this.perPage})
              .then(response=>{
              //console.log("here",  response.data);
                  this.items = response.data.Contents;
                  this.totalRows = response.data.totalElements;
              })
              .catch(error=>{
                  // this.$notify({
                  //     title: 'Error',
                  //     text: error.response.data,
                  //     type: 'error'
                  // })
                  //console.log(error);
              })
              .finally(msg=>{
                this.spinner =false;
              })
            }
          }
        },
        changePage(event, page){
          this.spinner = true;
          if(this.DateEnd !== "" && this.DateEnd !== null && this.DateEnd !== undefined){
            if(this.ekubStatus === "Completed"){
              this.disabledData = false;
             this.$store.dispatch('getAllAssociationLinkageCompleted', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: page, line: this.perPage, startDate: this.DateFrom, endDate: this.DateTo})
              .then(response=>{
                  this.items = response.data.Contents;
                  this.totalRows = response.data.totalElements;
              })
              .catch(error=>{
                  // this.$notify({
                  //     title: 'Error',
                  //     text: error.response.data,
                  //     type: 'error'
                  // })
                  //console.log(error);
              })
              .finally(msg=>{
                this.spinner =false;
              })
            }else{
              this.disabledData = true;
              this.$store.dispatch('getAllAssociationLinkageNotCompleted', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: page, line: this.perPage, startDate: this.DateFrom, endDate: this.DateTo})
              .then(response=>{
                  this.items = response.data.Contents;
                  this.totalRows = response.data.totalElements;
              })
              .catch(error=>{
                  // this.$notify({
                  //     title: 'Error',
                  //     text: error.response.data,
                  //     type: 'error'
                  // })
                 // console.log(error);
              })
              .finally(msg=>{
                this.spinner =false;
              })
            }
          }else{    
            if(this.ekubStatus === "Completed"){
              this.disabledData = false;
              this.$store.dispatch('getAllAssociationLinkageCompleted', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: page, line: this.perPage})
              .then(response=>{
                  this.items = response.data.Contents;
                  this.totalRows = response.data.totalElements;
              })
              .catch(error=>{
                  // this.$notify({
                  //     title: 'Error',
                  //     text: error.response.data,
                  //     type: 'error'
                  // })
                 // console.log(error);
              })
              .finally(msg=>{
                this.spinner =false;
              })
            }else{
              this.disabledData = true;
              this.$store.dispatch('getAllAssociationLinkageNotCompleted', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: page, line: this.perPage})
              .then(response=>{
                  this.items = response.data.Contents;
                  this.totalRows = response.data.totalElements;
              })
              .catch(error=>{
                  // this.$notify({
                  //     title: 'Error',
                  //     text: error.response.data,
                  //     type: 'error'
                  // })
                 // console.log(error);
              })
              .finally(msg=>{
                this.spinner =false;
              })
            }
          }
        },
        changePerPage(event){
          this.spinner = true;
          if(this.DateEnd !== "" && this.DateEnd !== null && this.DateEnd !== undefined){
            if(this.ekubStatus === "Completed"){
              this.disabledData = false;
              this.$store.dispatch('getAllAssociationLinkageCompleted', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: this.currentPage, line: this.perPage, startDate: this.DateFrom, endDate: this.DateTo})
              .then(response=>{
                  this.items = response.data.Contents;
                  // console.log("items ",response.data.Contents);
                  this.totalRows = response.data.totalElements;
              })
              .catch(error=>{
                  // this.$notify({
                  //     title: 'Error',
                  //     text: error.response.data,
                  //     type: 'error'
                  // })
                  //console.log(error);
              })
              .finally(msg=>{
                this.spinner =false;
              })
            }else{
              this.disabledData = true;
               this.$store.dispatch('getAllAssociationLinkageNotCompleted', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: this.currentPage, line: this.perPage, startDate: this.DateFrom, endDate: this.DateTo})
              .then(response=>{
                  this.items = response.data.Contents;
                  this.totalRows = response.data.totalElements;
              })
              .catch(error=>{
                  // this.$notify({
                  //     title: 'Error',
                  //     text: error.response.data,
                  //     type: 'error'
                  // })
                  //console.log(error);
              })
              .finally(msg=>{
                this.spinner =false;
              })
            }
          }else{
             if(this.ekubStatus === "NotCompleted"){
              this.disabledData = false;
              this.$store.dispatch('getAllAssociationLinkageNotCompleted', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: this.currentPage, line: this.perPage})
              .then(response=>{
                  this.items = response.data.Contents;
                  // console.log("items ",this.items);
                  this.totalRows = response.data.totalElements;
              })
              .catch(error=>{
                  // this.$notify({
                  //     title: 'Error',
                  //     text: error.response.data,
                  //     type: 'error'
                  // })
                  //console.log(error);
              })
              .finally(msg=>{
                this.spinner =false;
              })
            }else{
              this.disabledData = true;
               this.$store.dispatch('getAllAssociationLinkageCompleted', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: this.currentPage, line: this.perPage})
              .then(response=>{
                  this.items = response.data.Contents;
                  this.totalRows = response.data.totalElements;
              })
              .catch(error=>{
                  // this.$notify({
                  //     title: 'Error',
                  //     text: error.response.data,
                  //     type: 'error'
                  // })
                 // console.log(error);
              })
              .finally(msg=>{
                this.spinner =false;
              })
            }
          }
        },
        LinkingEkub(){
          this.$bvModal.show('modal-top-add');
        },
        submitAddForm(){
         if(this.file !== null){
          if(this.file.type !="application/pdf"){
            this.$notifications.notify(
            {
              message: "Invalid document format Only Pdf file allowed",
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
            })
            return;
          }
          if(this.file.size > 2000000){
            this.$notifications.notify(
            {
              message: "Document size should not be exceed 2MB",
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
            })
            return;
          }
         }
          this.$bvModal.msgBoxConfirm(translate('areYouSureYouWantToSubmitThisForm'), {
                title: translate('confirm'),
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                cancelVariant: 'danger',
                okTitle:  translate('yes'),
                cancelTitle: translate('nono'),
                bodyClass: 'm-2',
                hideHeaderClose: false,
                centered: false
            })
            .then(value => {
                if(value === true){
                  var fileToAttach = "";
                  var cycle = this.addData.cycle * this.addData.cycletwo;
  
                  if(this.base64 != null){
                    fileToAttach = this.base64.split(',')[1];
                  }
                  if(this.checkedExistingEkubType && this.checkedExistingEkubMember){
                    var submitForm = {
                      ekubId: this.addData.ekubId,
                      ekubJoinerId : this.addData.ekubJoinerId,
                      startDate: this.addData.startDate,
                      amount: this.addData.amount,
                      registeredBy: sessionStorage.getItem("userID"),
                      superUserId: parseInt(sessionStorage.getItem("superID")),
                      userId: sessionStorage.getItem("ID"),
                      numberOfEkub: this.addData.amount,
                      linkingDescription: this.addData.linkingDescription,
                        ekubTypeDescription: this.addData.ekubTypeDescription,
                        memberDescription: this.memberDescription,
                      encodePdf: fileToAttach
                    }
                    this.$store.dispatch('CreateEkubLinkExistingEkubTypeEkubMember', submitForm)
                    .then(response=>{
                        this.$notifications.notify(
                          {
                            message: `<span>The data successfully created.</span>`,
                            horizontalAlign: 'center',
                            verticalAlign: 'top',
                            type: 'success'
                          })
                          this.$bvModal.hide('modal-top-add');
                          this.clearData();
                    })
                    .catch(error=>{
                       this.$notifications.notify(
                            {
                              message: error.response.data,
                              horizontalAlign: 'center',
                              verticalAlign: 'top',
                              type: 'danger'
                            })
                        //console.log(error);
                    })
                  }else if(!this.checkedExistingEkubType && this.checkedExistingEkubMember){
                     var submitForm = {
                      ekubName : this.addData.ekubName,
                      ekubType: this.addData.ekubType,
                      numberOfEkuber: this.addData.numberOfEkuber,
                      description: this.addData.description,
                      cycleDuration: this.addData.cycleDuration,
                      ekubAmount:parseFloat( this.addData.ekubAmount),
                      ekubStartDate: this.addData.startDate,
                      cycle: cycle,
                      ekubId: this.addData.ekubId,
                      ekubJoinerId : this.addData.ekubJoinerId,
                      startDate: this.addData.startDate,
                      numberOfEkub: this.addData.amount,
                      amountPerOne: this.addData.amountPerOne,
                      registeredBy: sessionStorage.getItem("userID"),
                      superUserId: parseInt(sessionStorage.getItem("superID")),
                      userId: sessionStorage.getItem("ID"),
                      linkingDescription: this.addData.linkingDescription,
                        ekubTypeDescription: this.addData.ekubTypeDescription,
                        memberDescription: this.memberDescription,
                      encodePdf: fileToAttach
                     }
                    this.$store.dispatch('CreateEkubLinkingNotEkubTypeExistingEkubMember', submitForm)
                    .then(response=>{
                        this.$notifications.notify(
                          {
                            message: `<span>The data successfully created.</span>`,
                            horizontalAlign: 'center',
                            verticalAlign: 'top',
                            type: 'success'
                          })
                          this.$bvModal.hide('modal-top-add');
                          this.clearData();
                    })
                    .catch(error=>{
                       this.$notifications.notify(
                            {
                              message: error.response.data,
                              horizontalAlign: 'center',
                              verticalAlign: 'top',
                              type: 'danger'
                            })
                        //console.log(error);
                    })
                  }else if(this.checkedExistingEkubType && !this.checkedExistingEkubMember){
                    var submitForm = {
                      fullName:this.addData.fullName,
                      email:this.addData.email,
                      sex: this.addData.sex,
                      phoneNumber: "+251"+this.addData.phoneNumber,
                      address: this.addData.address,
                      job: this.addData.job,
                      ekubStartDate: this.addData.startDate,
                      idNumber: this.addData.idNumber,
                      numberOfEkub: this.addData.amount,
                      ekubId: this.addData.ekubId,
                      ekubJoinerId : this.addData.ekubJoinerId,
                      startDate: this.addData.startDate,
                      amount: this.addData.amount,
                      amountPerOne: this.addData.amountPerOne,
                      registeredBy: sessionStorage.getItem("userID"),
                      superUserId: parseInt(sessionStorage.getItem("superID")),
                      userId: sessionStorage.getItem("ID"),
                      linkingDescription: this.addData.linkingDescription,
                        ekubTypeDescription: this.addData.ekubTypeDescription,
                        memberDescription: this.memberDescription,
                      encodePdf: fileToAttach
                    };
                    this.$store.dispatch('CreateEkubLinkingNotEkubMemberExistingEkubType', submitForm)
                    .then(response=>{
                        this.$notifications.notify(
                          {
                            message: `<span>The data successfully created.</span>`,
                            horizontalAlign: 'center',
                            verticalAlign: 'top',
                            type: 'success'
                          })
                          this.$bvModal.hide('modal-top-add');
                          this.clearData();
                    })
                    .catch(error=>{
                       this.$notifications.notify(
                            {
                              message: error.response.data,
                              horizontalAlign: 'center',
                              verticalAlign: 'top',
                              type: 'danger'
                            })
                        //console.log(error);
                    })
                  }else{
                     var submitForm = {
                      ekubName : this.addData.ekubName,
                      ekubType: this.addData.ekubType,
                      numberOfEkuber: this.addData.numberOfEkuber,
                      description: this.addData.description,
                      cycleDuration: this.addData.cycleDuration,
                      ekubAmount:parseFloat( this.addData.ekubAmount),
                      ekubStartDate: this.addData.startDate,
                      cycle: cycle,
                      fullName:this.addData.fullName,
                      email:this.addData.email,
                      sex: this.addData.sex,
                      phoneNumber: "+251"+this.addData.phoneNumber,
                      address: this.addData.address,
                      job: this.addData.job,
                      numberOfEkub: this.addData.amount,
                      idNumber: this.addData.idNumber,
                      ekubId: this.addData.ekubId,
                      ekubJoinerId : this.addData.ekubJoinerId,
                      startDate: this.addData.startDate,
                      amount: this.addData.amount,
                      amountPerOne: this.addData.amountPerOne,
                      registeredBy: sessionStorage.getItem("userID"),
                      superUserId: parseInt(sessionStorage.getItem("superID")),
                      userId: sessionStorage.getItem("ID"),
                      linkingDescription: this.addData.linkingDescription,
                        ekubTypeDescription: this.addData.ekubTypeDescription,
                        memberDescription: this.memberDescription,
                      encodePdf: fileToAttach
                    };
                    this.$store.dispatch('CreateEkubLinkingNotEkubMemberNotEkubType', submitForm)
                    .then(response=>{
                        this.$notifications.notify(
                          {
                            message: `<span>The data successfully created.</span>`,
                            horizontalAlign: 'center',
                            verticalAlign: 'top',
                            type: 'success'
                          })
                          this.$bvModal.hide('modal-top-add');
                          this.clearData();
                    })
                    .catch(error=>{
                       this.$notifications.notify(
                        {
                          message: error.response.data,
                          horizontalAlign: 'center',
                          verticalAlign: 'top',
                          type: 'danger'
                        })
                       // console.log(error);
                    })
                  }
                }
            })
            .catch(error=>{
               // console.log(error)
            })
        },
        ViewDetail(ID){
          this.$store.dispatch('GetContractDetailById', {contractId: ID})
          .then(response=>{
            this.selectedContract = response.data;
            //console.log("herea", response.data);
              this.$bvModal.show('modal-top-Details');
              this.clearData();
          })
          .catch(error=>{
            this.$notifications.notify(
                {
                  message: error.response.data,
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
                })
              //console.log(error);
          })
        },
        EditLinkage(ID){
          var selected = this.items.filter(item=> item.ekubLinkId == ID)[0];
          this.editData.id = ID;
          this.editData.ekubTypeId = selected.ekubType.id;
          this.editData.numberOfEkub = selected.numberOfEkub;
          this.editData.ekubMembers = selected.ekubMembers.id;
          this.$bvModal.show('modal-top-EditLinkage');
        },
         submitEditForm(){
          if(this.file !== null){
            if(this.file.type !="application/pdf"){
              this.$notifications.notify(
              {
                message: "Invalid document format",
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'danger'
              })
              return;
            }
            if(this.file.size > 2000000){
              this.$notifications.notify(
              {
                message: "Document size should not be exceed 2MB",
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'danger'
              })
              return;
            }
         }
          this.$bvModal.msgBoxConfirm(translate('areYouSureYouWantToSubmitThisForm'), {
                title: translate('confirm'),
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                cancelVariant: 'danger',
                okTitle:  translate('yes'),
                cancelTitle: translate('nono'),
                bodyClass: 'm-2',
                hideHeaderClose: false,
                centered: false
            })
            .then(value => {
                if(value === true){
                  var fileToAttach = "";
  
                  if(this.base64 != null){
                    fileToAttach = this.base64.split(',')[1];
                  }
  
                  if(fileToAttach == ""){
                    fileToAttach = this.editData.encodedPdf == null ? "" : this.editData.encodedPdf;
                  }
  
                  var period = this.editData.period * this.editData.periodtwo;
                  this.$store.dispatch('EditAssocationLinkage', {
                    ekubJoinerId : this.editData.ekubMembers,
                    ekubId : this.editData.ekubTypeId,
                    numberOfEkub : this.editData.numberOfEkub,
                    userId: sessionStorage.getItem("userID"),
                    id : this.editData.id,
                      encodePdf: fileToAttach
                  })
                    .then(response=>{
                        this.$notifications.notify(
                          {
                            message: `<span>Assocation linkage successfully updated.</span>`,
                            horizontalAlign: 'center',
                            verticalAlign: 'top',
                            type: 'success'
                          })
                          this.$bvModal.hide('modal-top-EditLinkage');
                          this.clearData();
                    })
                    .catch(error=>{
                       this.$notifications.notify(
                        {
                          message: error.response.data,
                          horizontalAlign: 'center',
                          verticalAlign: 'top',
                          type: 'danger'
                        })
                       // console.log(error);
                    })
                }
            })
            .catch(error=>{
               // console.log(error)
            })
         },
         downloadFile(ID){
          this.$store.dispatch('GetContractFile', {contractId:ID})
            .then(response=>{
                if(response.data.encodedPdf !="" && response.data.encodedPdf !=null){
                  const linkSource = `data:application/pdf;base64,${response.data.encodedPdf}`;
                   const downloadLink = document.createElement("a");
                   const fileName = "document1.pdf";
   
                   downloadLink.href = linkSource;
                   downloadLink.download = fileName;
                   downloadLink.click();
                }else{
                  this.$notifications.notify(
                  {
                    message: "No document attached to this contract.",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                  })
                }
            })
            .catch(error=>{
                this.$notifications.notify(
                {
                  message: error.response.data,
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
                })
               // console.log(error);
            })
         },
         DisableContract(){
            this.$bvModal.show('modal-top-disable');
         },
         searchContractByID(){
          this.$store.dispatch('GetContractByID', {contractIdentifier: this.contractId, userId: parseInt(sessionStorage.getItem("ID"))})
            .then(response=>{
                this.disableContractData = response.data;
                this.$bvModal.show('modal-top-disable-detail');
            })
            .catch(error=>{
                this.$notifications.notify(
                {
                  message: error.response.data,
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
                })
                // console.log(error);
            })
         },
         SubmitDisableContract(ID){
          var msgt  = "";
          if(this.disableContractData.remainingDate !=="No remaining Date.") {
            msgt += "The tenant is already paid for "+this.disableContractData.remainingDate+ " days. ";
          }
          this.$bvModal.msgBoxConfirm(msgt+'Are you sure you want to terminate this contract?', {
              title: 'Confirm',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              cancelVariant: 'danger',
              okTitle: 'YES',
              cancelTitle: 'NO',
              bodyClass: 'm-2',
              hideHeaderClose: false,
              centered: false
          })
          .then(value => {
              if(value === true){
                this.$store.dispatch('disableContract', {contractIdentifier: ID})
                .then(response=>{
                    this.$notifications.notify(
                    {
                      message: `<span>Contract terminated successfully.</span>`,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'success'
                    })
                    this.$bvModal.hide('modal-top-disable-detail');
                    this.$bvModal.hide('modal-top-disable');
                    this.clearData();
                })
                .catch(error=>{
                    this.$notifications.notify(
                    {
                      message: error.response.data,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'danger'
                    })
                   // console.log(error);
                })
              }
          })
          .catch(error=>{
           // console.log(error);
          })
         },
        EnableContract(ID){
          this.$bvModal.show('modal-top-EnableContract');
          this.editData.contractIdentifier = ID;
        },
        submitEnableForm(){
          this.$bvModal.msgBoxConfirm('Are you sure you want to renew this contract?', {
              title: 'Confirm',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              cancelVariant: 'danger',
              okTitle: 'YES',
              cancelTitle: 'NO',
              bodyClass: 'm-2',
              hideHeaderClose: false,
              centered: false
          })
          .then(value => {
              if(value === true){
                var fileToAttach = "";
  
                  if(this.base64 != null){
                    fileToAttach = this.base64.split(',')[1];
                  }
  
                  if(fileToAttach == ""){
                    fileToAttach = this.editData.encodedPdf == null ? "" : this.editData.encodedPdf;
                  }
  
                var period = this.editData.period * this.editData.periodtwo;
                this.$store.dispatch('enableContract', {
                  userId : sessionStorage.getItem("ID"),
                  contractIdentifier: this.editData.contractIdentifier,
                  startDate : this.editData.startDate,
                  endDate : this.editData.endDate,
                  initialPayment:  this.editData.initialPayment,
                  guaranteedMoney: this.editData.guaranteedMoney,
                  dueDate : this.editData.dueDate,
                  period: period,
                  encodePdf: fileToAttach,
                  registeredBy: sessionStorage.getItem("userID")
                })
                .then(response=>{
                    this.$notifications.notify(
                    {
                      message: `<span>Contract Renewed successfully.</span>`,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'success'
                    })
                    this.clearData();
                })
                .catch(error=>{
                    this.$notifications.notify(
                    {
                      message: error.response.data,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'danger'
                    })
                   // console.log(error);
                })
              }
          })
          .catch(error=>{
          //  console.log(error);
          })
        },
        toggleFilters() {
          this.showFilters = !this.showFilters;
        },
        clearFilters() {
          this.phoneNumber = '';
          this.getEkubLinksByOwnerID();
        },
        searchByPhoneNumber() {
          if (!this.phoneNumber) {
            this.$notifications.notify({
              message: 'Please enter a phone number',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'warning'
            });
            return;
          }
          
          this.spinner = true;
          this.$store.dispatch('getEkubByPhoneNumber', {
            superUserId: parseInt(sessionStorage.getItem("superID")),
            phoneNumber: "+251" + this.phoneNumber
          })
          .then(response => {
            this.items = response.data.contents;
            this.totalRows = response.data.totalElements;
          })
          .catch(error => {
            this.$notifications.notify({
              message: error.response.data || 'Error searching by phone number',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
            });
          })
          .finally(() => {
            this.spinner = false;
          });
        },
        openTerminateModal() {
          this.$bvModal.show('modal-terminate');
        },
        searchForTerminate() {
          if (!this.terminateData.searchPhone) {
            this.$notifications.notify({
              message: 'Please enter a phone number',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'warning'
            });
            return;
          }
          
          this.$store.dispatch('getEkubByPhoneNumber', {
            superUserId: parseInt(sessionStorage.getItem("superID")),
            phoneNumber: "+251" + this.terminateData.searchPhone
          })
          .then(response => {
            this.terminateData.searchResults = response.data.contents;
            this.terminateData.searched = true;
          })
          .catch(error => {
            this.$notifications.notify({
              message: error.response.data || 'Error searching by phone number',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
            });
          });
        },
        confirmTerminate(item) {
          this.$bvModal.msgBoxConfirm(`Are you sure you want to terminate the linkage for ${item.ekubMembers.fullName} in ${item.ekubType.ekubName}?`, {
            title: 'Confirm Termination',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            cancelVariant: 'secondary',
            okTitle: 'Terminate',
            cancelTitle: 'Cancel',
            bodyClass: 'm-2',
            hideHeaderClose: false,
            centered: false
          })
          .then(confirmed => {
            if (confirmed) {
              this.$store.dispatch('terminateEkubLinking', { linkingId: item.ekubLinkId })
                .then(response => {
                  this.$notifications.notify({
                    message: 'Association linkage terminated successfully',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                  });
                  this.$bvModal.hide('modal-terminate');
                  this.clearTerminateData();
                  this.getEkubLinksByOwnerID();
                })
                .catch(error => {
                  this.$notifications.notify({
                    message: error.response.data || 'Error terminating linkage',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                  });
                });
            }
          });
        },
        clearTerminateData() {
          this.terminateData.searchPhone = '';
          this.terminateData.searchResults = [];
          this.terminateData.searched = false;
        },
        clearData(){
          this.ekubMemberOptions = [];
          this.ekubTypeOptions = [];
          this.checkedExistingEkubType = this.checkedExistingEkubMember = false;
          this.addData.amount=null;
          this.addData.amountPerOne="";
          this.addData.ekubName="";
          this.addData.ekubType="";
          this.addData.ekubAmount=null;
          this.addData.cycleDuration=null;
          this.addData.email="";
          this.addData.phoneNumber="";
          this.addData.address="";
          this.addData.startDate="";
          this.addData.numberOfEkuber=null;
          this.addData.cycle=0;
          this.addData.job=null;
          this.addData.idNumber = null;
          this.addData.ekubLinkingId= null;
          this.addData.ekubJoinerId= null;
          this.addData.ekubId= null;
          this.editData.ekubMembers= "";
          this.editData.ekubTypeId= "";
          this.editData.numberOfEkub= 0;
          this.base64 = null;
          this.tabIndex = 0;
          this.clearTerminateData();
          this.$emit('AfterComplete');
        }
      }
    }
  </script>
  <style lang="scss" scoped>
    @media only screen and (max-width: 600px) {
      .mob-title{
        display: none !important;
      }
    }
  .b-table-sticky-column:last-child {
    right: 0;
  }
  .text-warning {
      color: rgba(240, 206, 13, 0.937) !important;
  }
  .btn-icon{
    font-size: 27px !important;
    padding: 3px 5px 3px 5px;
    width: 40px;
    color:  rgb(37, 91, 48);
    border: 2px solid rgb(37, 91, 48);
  }
  .btn-icon:hover,
  .btn-icon:focus {
    cursor: pointer;
    background-color: rgb(37, 91, 48) !important;
    color: rgba(240, 206, 13, 0.937) !important;
    border-radius: 4px;
    transition: .4s;
  }
  .mt-3 {
  margin-top: 1rem !important;
}
.table-container {
  display: flex;
  flex-direction: column;
  max-height: calc(80vh - 0px); /* Adjust depending on other UI elements */
  overflow-y: auto;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* Mobile adjustments */
@media (max-width: 768px) {
  .custom-dropdown {
    max-width: 100%; /* Ensure dropdown expands on mobile */
  }

  .pagination-container {
    margin-top: 20px;
  }

  .table-container {
    max-height: 50vh; /* Lower height for better mobile usability */
  }

  .b-button-toolbar {
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .b-button {
    padding: 8px;
    margin: 5px;
  }
  .table-container {
  max-height: 50vh;
  overflow-y: auto;
  overflow-x: auto;
}
}
.sticky-header {
  position: sticky;
  top: 0;
  background-color: #fff; /* Ensure header has a background */
  z-index: 1; /* Ensure it stays on top of the table body */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Optional: Add shadow for better visibility */
}
  </style>